import * as ActiveStorage from "@rails/activestorage";
import "controllers";

let Turbo;

try {
  ({ Turbo } = require("@hotwired/turbo-rails"));
} catch (error) {
  Turbo = window.Turbo;
}

// Turbo Drive stays disabled to preserve existing $(document).ready
// initialisation (Parsley, jQuery plugins, etc.). Turbo Frames and Streams
// remain fully functional via per-element opt-in (see
// docs/hotwire-refactor-plans/README.md):
//
//   - Forms opt in with data-turbo="true"; success responses render
//     .turbo_stream.erb templates targeting plain DOM ids, and validation
//     failures re-render the form via a stream with a 422 status.
//   - <turbo-frame> elements are intercepted regardless of this setting;
//     use them only where lazy loading or scoped navigation is wanted.
//   - Never use data-remote: jquery_ujs is still loaded via sprockets and
//     would also intercept the form.
if (Turbo && Turbo.session) {
  Turbo.session.drive = false;
}

ActiveStorage.start();

addEventListener("direct-upload:initialize", (event) => {
  const { target, detail } = event;
  const { id, file } = detail;
  target.insertAdjacentHTML(
    "beforebegin",
    `
    <div id="direct-upload-${id}" class="direct-upload direct-upload--pending">
      <div id="direct-upload-progress-${id}" class="direct-upload__progress" style="width: 0%"></div>
      <span class="direct-upload__filename"></span>
    </div>
  `,
  );
  target.previousElementSibling.querySelector(
    `.direct-upload__filename`,
  ).textContent = file.name;
});

addEventListener("direct-upload:start", (event) => {
  const { id } = event.detail;
  const element = document.getElementById(`direct-upload-${id}`);
  element.classList.remove("direct-upload--pending");
});

addEventListener("direct-upload:progress", (event) => {
  const { id, progress } = event.detail;
  const progressElement = document.getElementById(
    `direct-upload-progress-${id}`,
  );
  progressElement.style.width = `${progress}%`;
});

addEventListener("direct-upload:error", (event) => {
  event.preventDefault();
  const { id, error } = event.detail;
  const element = document.getElementById(`direct-upload-${id}`);
  element.classList.add("direct-upload--error");
  element.setAttribute("title", error);
});

addEventListener("direct-upload:end", (event) => {
  const { id } = event.detail;
  const element = document.getElementById(`direct-upload-${id}`);
  element.classList.add("direct-upload--complete");
});
